import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SkeletonLoaderService {
  private static uniqueSkeletonId = -1;
  uniqueId = '';

  constructor() {}

  getLoaderId(): string {
    return `${++SkeletonLoaderService.uniqueSkeletonId}`;
  }
}
